module.exports = __webpack_public_path__ + "media/achtergrond_muziek.93feca9d.mp3";